import { render } from "./MFeedCompute.vue?vue&type=template&id=3879fd61&ts=true"
import script from "./MFeedCompute.vue?vue&type=script&lang=ts"
export * from "./MFeedCompute.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\work\\monster-tools\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__